import React from "react";

function Section(props) {
  const {
    size,
    bgColor = "bg-white",
    textColor,
    className,
    children,
    bgImage,
    bgImageOpacity,
    ...otherProps
  } = props;

  return (
    <section
      className={
        "section relative" +
        (bgColor ? ` ${bgColor}` : "") +
        (textColor ? ` ${textColor}` : "") +
        (className ? ` ${className}` : "")
      }
      {...otherProps}
    >
      <div
        className={
          "[&>.container]:relative" +
          (size === "sm" ? " py-10" : "") +
          (size === "md" ? " py-10 md:py-20" : "") +
          (size === "lg" ? " py-10 md:py-32" : "")
        }
      >
        {props.children}
      </div>
    </section>
  );
}

export default Section;
